import { PreLoading } from 'global/components/LoadingCustumer'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '../hooks'

export function PublicRoutes() {
    const location = useLocation()
    const { auth, isRestaurandoSessao } = useAuth()

    // Sem isso o formulário de login aparece e some ao concluir a renovação
    if (isRestaurandoSessao) return <PreLoading />

    // Não está autenticado
    if (!auth) return <Outlet />

    // Está autenticado, clicou em um plano pela landing page
    if (location.pathname === '/checkout')
        return (
            <Navigate
                to={`/planos/checkout${location.search}`}
                state={{ from: '/' }}
                replace
            />
        )

    // Está autenticado, tentou acessar uma rota pública
    return <Navigate to="/dashboard" state={{ from: location }} replace />
}
